"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import c from "../components/Icon/SvgIcon.js";
const e = (l) => /* @__PURE__ */ o(
  c,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.004 5.65A2.375 2.375 0 0 0 2 7.994v9.76a2.375 2.375 0 0 0 2.375 2.375h15.254a2.375 2.375 0 0 0 2.375-2.375V9.502a2.375 2.375 0 0 0-2.375-2.375h-.567V6.048a2.375 2.375 0 0 0-2.745-2.345L4.004 5.649Zm13.808.398c0-.691-.617-1.219-1.3-1.11L4.199 6.883a1.12 1.12 0 0 0-.705.412c.272-.11.57-.17.881-.17h13.438V6.049ZM3.25 17.755V9.502c0-.622.504-1.125 1.125-1.125h15.254c.621 0 1.125.503 1.125 1.125v8.253c0 .621-.504 1.125-1.125 1.125H4.375a1.125 1.125 0 0 1-1.125-1.125m10.314-7.491c.685 0 1.374.093 1.98.261l-.414 2.42c-.414-.346-.961-.641-1.646-.641-.907 0-1.761.548-1.905 1.239-.145.7.528 1.239 1.434 1.239.697 0 1.296-.227 1.858-.59l-.582 2.377c-.523.177-1.666.253-2.208.253-2.376 0-3.941-1.408-3.565-3.22.385-1.854 2.605-3.338 5.048-3.338",
        clipRule: "evenodd"
      }
    )
  }
), h = t(e);
export {
  h as CostcoWallet,
  h as default
};
